<script>
import { mapGetters } from 'vuex';
import MessageFormatter from 'shared/helpers/MessageFormatter';

export default {
  name: 'ImportantMessageModal',

  computed: {
    ...mapGetters({
      pendingMessages: 'importantMessages/getPendingMessages',
    }),
    currentMessage() {
      return this.pendingMessages[0] || null;
    },
    renderedContent() {
      if (!this.currentMessage) return '';
      return new MessageFormatter(this.currentMessage.content).formattedMessage;
    },
  },

  methods: {
    async confirmRead() {
      await this.$store.dispatch(
        'importantMessages/markAsRead',
        this.currentMessage.id
      );
    },
  },
};
</script>

<template>
  <Teleport to="body">
    <Transition name="important-message">
      <div
        v-if="currentMessage"
        class="fixed inset-0 z-[9990] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm"
      >
        <div
          class="relative w-full max-w-lg max-h-[85vh] flex flex-col rounded-2xl shadow-2xl bg-white dark:bg-slate-800 overflow-hidden"
          @click.stop
        >
          <div class="flex-1 overflow-y-auto p-6">
            <h2
              class="text-lg font-semibold text-slate-900 dark:text-slate-50 mb-4 leading-snug"
            >
              {{ currentMessage.title }}
            </h2>
            <div
              v-dompurify-html="renderedContent"
              class="prose prose-sm dark:prose-invert max-w-none text-slate-700 dark:text-slate-300"
            />
          </div>

          <div
            class="flex-shrink-0 flex justify-end px-6 py-4 border-t border-slate-100 dark:border-slate-700"
          >
            <button
              class="px-5 py-2 text-sm font-semibold text-white bg-woot-500 rounded-lg hover:bg-woot-600 active:bg-woot-700 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-woot-500"
              @click="confirmRead"
            >
              {{ $t('IMPORTANT_MESSAGES.CONFIRM_READ') }}
            </button>
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<style scoped>
.important-message-enter-active,
.important-message-leave-active {
  transition: opacity 0.2s ease;
}

.important-message-enter-active .relative,
.important-message-leave-active .relative {
  transition: transform 0.2s ease, opacity 0.2s ease;
}

.important-message-enter-from,
.important-message-leave-to {
  opacity: 0;
}

.important-message-enter-from .relative {
  transform: scale(0.95) translateY(8px);
  opacity: 0;
}

.important-message-leave-to .relative {
  transform: scale(0.95) translateY(8px);
  opacity: 0;
}
</style>
